import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PRIMARY_SITE_URL } from '../../config/siteContent';

const SITE_NAME = 'Reddicks';
const SITE_URL = PRIMARY_SITE_URL;
const DEFAULT_TITLE = 'Reddicks - Base-First Memecoin with Live Utility';
const DEFAULT_DESCRIPTION =
  'The home of $REDDICKS - a trust-first memecoin with live utility on Radix and Base, transparent lock messaging, and ecosystem-funded growth.';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const SEOHead = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  robots = 'index, follow',
  breadcrumbs = null,
  extraSchema = null,
  siteUrl = SITE_URL,
  canonicalUrl = null,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const resolvedCanonicalUrl = canonicalUrl || `${siteUrl}${path}`;

  const breadcrumbSchema = breadcrumbs
    ? {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: crumb.name,
          item: `${siteUrl}${crumb.path}`,
        })),
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={resolvedCanonicalUrl} />
      <meta name="robots" content={robots} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={resolvedCanonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}

      {extraSchema && <script type="application/ld+json">{JSON.stringify(extraSchema)}</script>}
    </Helmet>
  );
};

export default SEOHead;
